import type { ReactNode } from 'react'
import React from 'react'

import { Icon, Tooltip, useMediaQueryContext } from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'

import * as S from './styled'

type SelectedItemProps = {
  children: ReactNode
  withMaxHeight?: boolean
  disabled?: boolean
  onRemove: () => void
}

export const SelectedItem = ({
  children,
  withMaxHeight,
  disabled,
  onRemove,
}: SelectedItemProps) => {
  const media = useMediaQueryContext()

  const RemoveButton = disabled ? null : (
    <S.RemoveButton onClick={onRemove}>
      <Icon component={CloseIcon} height={media.laptop ? 16 : 14} />
    </S.RemoveButton>
  )

  return (
    <S.Container>
      <S.Content>{children}</S.Content>
      <S.RemoveButtonWrapper inside={withMaxHeight}>
        {media.laptop ? (
          <Tooltip reference={RemoveButton} placement={withMaxHeight ? 'left' : 'bottom'}>
            Remove
          </Tooltip>
        ) : (
          RemoveButton
        )}
      </S.RemoveButtonWrapper>
    </S.Container>
  )
}
